import React from 'react';
import { Outlet } from 'react-router-dom';
import { NavigationBar } from '../navigation';
import { useResponsive } from '../../hooks';
import { DesktopScannerButton } from '../scanner';
import ResponsiveLayout from './ResponsiveLayout';

const MainLayout: React.FC = () => {
  const responsive = useResponsive();
  const isMobile = responsive.isSmallerThan('md');
  
  const contentClass = isMobile 
    ? 'pb-20' // Add bottom padding for mobile to account for bottom navigation
    : ''; 

  return (
    <>
      <NavigationBar />
      <ResponsiveLayout>
        <main className={contentClass}>
          <Outlet />
        </main>
      </ResponsiveLayout>
      <DesktopScannerButton />
    </>
  );
};

export default MainLayout; 